import axios from "axios";

export const ApiPesquisa = axios.create({
  baseURL: process.env.REACT_APP_API_PESQUISA_SATISFACAO_URL,
  headers: {
    "Content-type": "application/json; charset=UTF-8",
  },
});

ApiPesquisa.interceptors.request.use(
  (config) => {
    let token;
    if (typeof window !== "undefined") {
      const localToken = sessionStorage.getItem("@token");

      if (localToken) {
        token = localToken.replaceAll('"', "");
      }

      if (token && config.headers !== undefined) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },

  (error) => Promise.reject(error)
);
